var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "sidebar", class: _vm.borderColor }, [
    _c("img", {
      staticClass: "logo",
      attrs: {
        src: require("../assets/images/logo.png"),
        alt: "IPSA ONE logo"
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.redirectToHome($event)
        }
      }
    }),
    _vm._v(" "),
    _c("h1", { staticClass: "title" }, [
      _vm._v("\n        Administration Network for Nanosat Association\n    ")
    ]),
    _vm._v(" "),
    _c("nav", [
      _c(
        "ul",
        _vm._l(_vm.links, function(link) {
          return _c(
            "li",
            { key: link.id },
            [
              link.name != "admin" || _vm.showAdmin
                ? _c(
                    "router-link",
                    {
                      class: [link.color, link.class],
                      attrs: { to: { name: link.name } }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(link.title) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bottom" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.tooltipVisible
            ? _c(
                "div",
                {
                  staticClass: "tooltip",
                  class: { redBorder: _vm.tooltipRedBorder }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(this.tooltipText) +
                      "\n            "
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "actions",
            on: {
              mouseover: _vm.mouseOverButton,
              mouseleave: _vm.mouseLeaveButton
            }
          },
          [
            _c(
              "router-link",
              {
                staticClass: "button",
                attrs: {
                  to: { name: "profile", params: { id: _vm.logged.id } },
                  "data-text": "Profile"
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-user",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "button",
                attrs: { "data-text": "Logout" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.logout($event)
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa fa-power-off",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }